/* LicensedTime Register Your Watch: team -> style -> band color, validation, then Shopify's native contact form
   (every field goes as contact[...]); confirmation state on success. */
(() => {
  'use strict';
  const root = document.querySelector('[data-lt-register]');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const form = document.getElementById('lt-reg-form');
  if (!form) return;
  const teamSel = $('[data-lt-reg-team]');
  const styleSel = $('[data-lt-reg-style]');
  const bandSel = $('[data-lt-reg-band]');
  const bandWrap = $('[data-lt-reg-bandwrap]');
  const pick = $('[data-lt-reg-pick]');
  const alertEl = $('[data-lt-reg-alert]');
  const submit = $('[data-lt-reg-submit]');
  const done = $('[data-lt-reg-done]');
  const SS = 'lt_reg_done_text';
  let team = null;
  let products = [];

  const f = (name) => form.elements[`contact[${name}]`];
  const today = new Date();
  f('Purchase date').max = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

  const say = (msg) => {
    alertEl.textContent = msg || '';
    alertEl.hidden = !msg;
  };
  const fieldErr = (key, el, on) => {
    const e = form.querySelector(`[data-err="${key}"]`);
    if (e) e.hidden = !on;
    if (el && el.setAttribute) el.setAttribute('aria-invalid', on ? 'true' : 'false');
  };
  const option = (value, label) => {
    const o = document.createElement('option');
    o.value = value;
    o.textContent = label;
    return o;
  };

  const showDone = (text) => {
    form.hidden = true;
    done.hidden = false;
    if (text) $('[data-lt-reg-donetext]').textContent = text;
    const shop = $('[data-lt-reg-shop]');
    if (team && team.live && team.u) {
      shop.href = team.u;
      shop.textContent = `Shop more ${team.s}`;
      if (/^#[0-9a-f]{3,8}$/i.test(team.p || '')) {
        shop.style.background = team.p;
        shop.style.color = /^#[0-9a-f]{3,8}$/i.test(team.op || '') ? team.op : '#fff';
      }
    }
    done.focus();
  };

  const loadTeams = (LT) => {
    LT.teams
      .filter((t) => t.live && t.u)
      .sort((a, b) => a.n.localeCompare(b.n))
      .forEach((t) => teamSel.appendChild(option(t.h, t.n)));
    const mine = LT.getMyTeam && LT.getMyTeam();
    if (mine && mine.live && mine.u) {
      teamSel.value = mine.h;
      onTeam();
    }
  };

  const onTeam = () => {
    team = window.LT.byHandle.get(teamSel.value) || null;
    styleSel.innerHTML = '';
    pick.hidden = true;
    bandWrap.hidden = true;
    products = [];
    if (!team) {
      styleSel.appendChild(option('', 'Choose a team first'));
      styleSel.disabled = true;
      return;
    }
    styleSel.appendChild(option('', 'Loading styles…'));
    styleSel.disabled = true;
    fetch(`${team.u}?view=lt-register`, { cache: 'no-store' })
      .then((r) => r.text())
      .then((t) => {
        products = JSON.parse(t).products || [];
        styleSel.innerHTML = '';
        styleSel.appendChild(option('', products.length ? 'Choose your style' : 'No styles found'));
        products.forEach((p, i) => styleSel.appendChild(option(String(i), p.style)));
        styleSel.disabled = !products.length;
      })
      .catch(() => {
        styleSel.innerHTML = '';
        styleSel.appendChild(option('', 'Could not load styles'));
      });
  };

  const onStyle = () => {
    const p = products[Number(styleSel.value)];
    if (!styleSel.value || !p) {
      pick.hidden = true;
      return;
    }
    const img = $('[data-lt-reg-img]');
    img.src = p.image || '';
    img.hidden = !p.image;
    $('[data-lt-reg-pickteam]').textContent = team ? team.s : '';
    $('[data-lt-reg-pickstyle]').textContent = p.style;
    bandSel.innerHTML = '';
    const bands = (p.bands || []).filter((b) => b && b !== 'Default Title');
    bands.forEach((b) => bandSel.appendChild(option(b, b)));
    $('[data-lt-reg-bandlabel]').textContent = p.bandLabel || 'Band color';
    bandWrap.hidden = bands.length < 2;
    pick.hidden = false;
  };

  teamSel.addEventListener('change', onTeam);
  styleSel.addEventListener('change', onStyle);

  const validate = () => {
    const v = (el) => String(el.value || '').trim();
    const checks = [
      ['team', teamSel, !teamSel.value],
      ['style', styleSel, !styleSel.value],
      ['purchase_date', f('Purchase date'), !/^\d{4}-\d{2}-\d{2}$/.test(v(f('Purchase date')))],
      ['first_name', f('First name'), !v(f('First name'))],
      ['last_name', f('Last name'), !v(f('Last name'))],
      ['email', f('email'), !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v(f('email')))]
    ];
    checks.forEach(([k, el, bad]) => fieldErr(k, el, bad));
    const first = checks.find((c) => c[2]);
    if (first) first[1].focus();
    return !first;
  };

  // Fill the contact[...] fields: subject line, a readable summary for the email body, and the hidden values
  const fill = () => {
    const p = products[Number(styleSel.value)];
    const teamName = team ? team.n : '';
    const styleName = p ? p.style : '';
    const band = bandWrap.hidden ? (p && p.bands && p.bands[0] && p.bands[0] !== 'Default Title' ? p.bands[0] : '') : bandSel.value;
    f('Team').value = teamName;
    f('Style').value = styleName;
    if (!band) f('Band color').disabled = true;
    else f('Band color').disabled = false;
    f('name').value = `${f('First name').value.trim()} ${f('Last name').value.trim()}`;
    f('Marketing opt-in').value = $('#lt-reg-optin').checked ? 'Yes' : 'No';
    f('Subject').value = `Watch registration: ${teamName} ${styleName}`.trim();
    const lines = [
      f('Subject').value,
      '',
      `Team: ${teamName}`,
      `Style: ${styleName}`,
      band ? `Band color: ${band}` : null,
      `Purchase date: ${f('Purchase date').value}`,
      `Where purchased: ${f('Where purchased').value}`,
      f('Order number').value.trim() ? `Order number: ${f('Order number').value.trim()}` : null,
      `Name: ${f('name').value}`,
      `Email: ${f('email').value.trim()}`,
      `Marketing opt-in: ${f('Marketing opt-in').value}`
    ].filter((x) => x !== null);
    f('body').value = lines.join('\n');
    return `Your ${team ? team.s + ' ' : ''}${styleName || 'watch'} is covered by a 3-year limited warranty. A confirmation is on its way to your email.`;
  };

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    say('');
    if ($('#lt-reg-website').value) {
      showDone(); // a bot filled the hidden field: pretend it worked, send nothing
      return;
    }
    if (!validate()) return;
    const doneText = fill();
    submit.disabled = true;
    submit.textContent = 'Registering…';
    const reset = () => {
      submit.disabled = false;
      submit.textContent = 'Register my watch';
    };
    fetch(form.action, { method: 'POST', body: new FormData(form), redirect: 'follow' })
      .then((r) => {
        if (/\/challenge/.test(r.url)) {
          // Shopify asked for its spam check: send the form the normal way so the check can show
          try {
            sessionStorage.setItem(SS, doneText);
          } catch (x) {}
          form.submit();
          return;
        }
        if (r.ok && /contact_posted=true/.test(r.url)) {
          showDone(doneText);
          return;
        }
        throw new Error('failed');
      })
      .catch(() => say('We could not send your registration just now. Please try again, or email us.'))
      .finally(reset);
  });

  root.querySelector('[data-lt-reg-again]').addEventListener('click', () => {
    form.reset();
    onTeam();
    done.hidden = true;
    form.hidden = false;
    if (window.history && history.replaceState) history.replaceState(null, '', window.location.pathname);
    teamSel.focus();
  });

  // Back from the normal (non-ajax) form post, or a review link
  const q = new URLSearchParams(window.location.search);
  if (q.get('contact_posted') === 'true' || q.get('state') === 'done') {
    let text = '';
    try {
      text = sessionStorage.getItem(SS) || '';
      sessionStorage.removeItem(SS);
    } catch (x) {}
    showDone(text || 'Your watch is covered by a 3-year limited warranty. A confirmation is on its way to your email.');
  }

  if (window.LT && window.LT.teams) loadTeams(window.LT);
  else document.addEventListener('lt:ready', () => loadTeams(window.LT), { once: true });
})();
